export const currentYear = new Date().getFullYear()
export const SYSTEM_TIMEZONE = Intl?.DateTimeFormat()?.resolvedOptions()
  ?.timeZone
